/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 履约报表-获取下拉筛选 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `GET /erp/PerformanceReport/optionsForList`
 */
const getOptionsForListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/optionsForList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表-获取下拉筛选 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `GET /erp/PerformanceReport/optionsForList`
 */
export const getOptionsForList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getOptionsForListRequestConfig, requestData), ...args);
};
getOptionsForList.requestConfig = getOptionsForListRequestConfig;
/**
 * 接口 履约报表详情 - 商品明细 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportGoodsDetail`
 */
const postReportGoodsDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/reportGoodsDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postReportGoodsDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表详情 - 商品明细 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportGoodsDetail`
 */
export const postReportGoodsDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postReportGoodsDetailRequestConfig, requestData),
    ...args
  );
};
postReportGoodsDetail.requestConfig = postReportGoodsDetailRequestConfig;
/**
 * 接口 履约报表-获取列表数据 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表-获取列表数据 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 履约报表详情-汇总 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportDetailSummary`
 */
const postReportDetailSummaryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/reportDetailSummary",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postReportDetailSummary",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表详情-汇总 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportDetailSummary`
 */
export const postReportDetailSummary = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postReportDetailSummaryRequestConfig, requestData),
    ...args
  );
};
postReportDetailSummary.requestConfig = postReportDetailSummaryRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/performanceReport.js